import React from "react";

import {
    AccountClass,
    AccountSubtype,
    AccountType,
} from "@common/constants/domains/accounting/accounts";
import { Account } from "@common/types/domains/accounting/account";
import {
    StandardModal,
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { CoAAccountCreateForm } from "./CoAAccountCreateForm";

interface Props {
    show: boolean;
    onHide: () => void;
    entityIds?: number[];
    hideEntitySelection?: boolean;
    accountName: string;
    accountType: AccountType;
    accountSubtype: AccountSubtype;
    parentGroupId?: string | null;
    availableClassifications?: AccountClass[];
    onAccountsCreated?: (accounts: Account[]) => void;
}

export const CreateCoAAccountModal: React.FC<Props> = ({
    entityIds,
    hideEntitySelection,
    show,
    onHide,
    accountName,
    accountType,
    accountSubtype,
    parentGroupId,
    availableClassifications,
    onAccountsCreated,
}) => (
    <StandardModal show={show} onHide={onHide}>
        <StandardModalHeader>Add Account</StandardModalHeader>
        <StandardModalBody>
            <CoAAccountCreateForm
                entityIds={entityIds}
                hideEntitySelection={hideEntitySelection}
                accountName={accountName}
                accountType={accountType}
                accountSubtype={accountSubtype}
                parentGroupId={parentGroupId}
                availableClassifications={availableClassifications}
                onAccountsCreated={onAccountsCreated}
                onCancel={onHide}
            />
        </StandardModalBody>
    </StandardModal>
);
